window.log = console.log.bind(console)
